import openPopupOperation from 'editor/src/store/app/module/popup/operation/openPopupOperation';
import getRollLength from 'editor/src/store/gangSheet/selector/getRollLength';
import type { ThunkDispatch } from 'editor/src/store/hooks';
import { RootState } from 'editor/src/store/index';

import { PopupName } from 'editor/src/component/Popup/popups';

// Tells the buyer that artwork could not be added because a rolling gang sheet is at its
// maximum length. The sheet itself is left exactly as it was.
const showSheetLengthLimitPopupOperation =
  (notAddedCount = 1) =>
  (dispatch: ThunkDispatch, getState: () => RootState) => {
    const rollLength = getRollLength(getState());
    if (!rollLength) {
      return;
    }
    const maxLength = rollLength.maxMm.toLocaleString('en-GB');
    dispatch(
      openPopupOperation(PopupName.LOCAL_CONFIRMATION_POPUP, {
        // TODO: Lokalino
        popupTitle:
          notAddedCount === 1
            ? "This artwork doesn't fit on the sheet"
            : `${notAddedCount} copies don't fit on the sheet`,
        textLines: [
          // TODO: Lokalino
          `A sheet can be at most ${maxLength} mm long, and there is no room left at that length. Your sheet has not changed. Make some artwork smaller, remove some, or try Auto nest to pack it tighter.`,
        ],
        options: [
          {
            // TODO: Lokalino
            title: 'OK',
            onConfirm: () => undefined,
          },
        ],
        hideTitleIcon: true,
      }),
    );
  };

export default showSheetLengthLimitPopupOperation;
